var _style, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoba(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 192.21 260.71",
    style: {
      enableBackground: "new 0 0 192.21 260.71"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#cf0}.st1{fill:#1cd8d2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.54 162.64c-3.15 0-5.81-2.25-6.34-5.36L45.27 51.86c-.29-1.7.1-3.4 1.1-4.8s2.48-2.33 4.17-2.62c3.5-.59 6.83 1.77 7.43 5.27L75.9 155.13c.29 1.7-.1 3.4-1.1 4.8a6.43 6.43 0 0 1-5.26 2.71z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.54 162.64c-3.15 0-5.81-2.25-6.34-5.36L45.27 51.86c-.29-1.7.1-3.4 1.1-4.8s2.48-2.33 4.17-2.62c3.5-.59 6.83 1.77 7.43 5.27L75.9 155.13c.29 1.7-.1 3.4-1.1 4.8a6.43 6.43 0 0 1-5.26 2.71z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.59 114.02c-10.25 0-19.78 3.07-27.75 8.34l2.17 12.76c6.85-5.97 15.8-9.6 25.58-9.6 21.51 0 39.01 17.5 39.01 39.01 0 21.51-17.5 39.01-39.01 39.01-21.51 0-39.01-17.5-39.01-39.01 0-2.87.32-5.66.91-8.35l-3.46-20.31a50.22 50.22 0 0 0-8.95 28.67c0 27.85 22.66 50.51 50.51 50.51s50.51-22.66 50.51-50.51-22.65-50.52-50.51-50.52z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 96.83,
    cy: 187.13,
    r: 6.88
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 118.32,
    cy: 179.12,
    r: 6.88
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 101.43,
    cy: 164.37,
    r: 6.88
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 80.07,
    cy: 171.4,
    r: 6.88
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 122.72,
    cy: 157.32,
    r: 6.88
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.02,
    cy: 141.61,
    r: 6.88
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.46,
    cy: 149.61,
    r: 6.88
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoba);
export default __webpack_public_path__ + "static/media/boba.834bef0e6102f659de098f61fbbaa96a.svg";
export { ForwardRef as ReactComponent };